const BRAND_STYLES = {
    facebook: {
        background: '#1877F2',
        color: '#FFFFFF',
    },
    twitter: {
        background: '#000000',
        color: '#FFFFFF',
    },
    instagram: {
        background: 'linear-gradient(135deg, #F9CE34 0%, #EE2A7B 52%, #6228D7 100%)',
        color: '#FFFFFF',
    },
    linkedin: {
        background: '#0A66C2',
        color: '#FFFFFF',
    },
    telegram: {
        background: '#229ED9',
        color: '#FFFFFF',
    },
    signal: {
        background: '#3A76F0',
        color: '#FFFFFF',
    },
    whatsapp: {
        background: '#25D366',
        color: '#FFFFFF',
    },
};

export function getBrandButtonStyle(type) {
    return BRAND_STYLES[type] || {
        background: '#111827',
        color: '#FFFFFF',
    };
}

function withProtocol(value) {
    if (!value) {
        return null;
    }

    if (/^[a-z][a-z\d+\-.]*:\/\//i.test(value)) {
        return value;
    }

    return `https://${value}`;
}

export function buildBrandLink(type, rawValue) {
    if (!rawValue) {
        return null;
    }

    const value = String(rawValue).trim();
    if (!value) {
        return null;
    }

    if (/^[a-z][a-z\d+\-.]*:\/\//i.test(value)) {
        return value;
    }

    switch (type) {
        case 'telegram': {
            const handle = value.replace(/^@+/, '').replace(/^(https?:\/\/)?(www\.)?t\.me\//i, '');
            return handle ? `https://t.me/${handle}` : null;
        }
        case 'signal': {
            const signalValue = value.replace(/^(https?:\/\/)?signal\.me\/#p\//i, '');
            const phone = signalValue.replace(/[^\d+]/g, '');
            if (!phone) {
                return null;
            }

            return `https://signal.me/#p/${phone.startsWith('+') ? phone : `+${phone}`}`;
        }
        case 'whatsapp': {
            const phone = value.replace(/^(https?:\/\/)?(wa\.me|api\.whatsapp\.com\/send\?phone=)/i, '').replace(/[^\d]/g, '');
            return phone ? `https://wa.me/${phone}` : null;
        }
        case 'facebook': {
            const handle = value.replace(/^https?:\/\/(www\.)?facebook\.com\//i, '');
            return withProtocol(handle.includes('.') ? value : `facebook.com/${handle}`);
        }
        case 'instagram': {
            const handle = value.replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/^@+/, '');
            return withProtocol(handle.includes('.') ? value : `instagram.com/${handle}`);
        }
        case 'linkedin': {
            const handle = value.replace(/^https?:\/\/(www\.)?linkedin\.com\//i, '');
            return withProtocol(handle.includes('.') ? value : `linkedin.com/${handle}`);
        }
        case 'twitter': {
            const handle = value
                .replace(/^https?:\/\/(www\.)?(x|twitter)\.com\//i, '')
                .replace(/^@+/, '');
            return withProtocol(handle.includes('.') ? value : `x.com/${handle}`);
        }
        default:
            return withProtocol(value);
    }
}

export function BrandIcon({ type, className = 'size-[18px]' }) {
    const props = {
        viewBox: '0 0 24 24',
        fill: 'currentColor',
        className,
        'aria-hidden': 'true',
    };

    switch (type) {
        case 'facebook':
            return (
                <svg {...props}>
                    <path d="M24 12.073C24 5.446 18.627.073 12 .073S0 5.446 0 12.073c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073Z" />
                </svg>
            );
        case 'twitter':
            return (
                <svg {...props}>
                    <path d="M18.9 2H22l-6.78 7.75L23 22h-6.1l-4.78-7.2L5.8 22H2.7l7.25-8.29L2 2h6.25l4.32 6.62L18.9 2Zm-1.07 17.95h1.7L7.3 3.96H5.48l12.35 15.99Z" />
                </svg>
            );
        case 'instagram':
            return (
                <svg {...props}>
                    <path d="M7.2 2h9.6A5.2 5.2 0 0 1 22 7.2v9.6A5.2 5.2 0 0 1 16.8 22H7.2A5.2 5.2 0 0 1 2 16.8V7.2A5.2 5.2 0 0 1 7.2 2Zm0 2A3.2 3.2 0 0 0 4 7.2v9.6A3.2 3.2 0 0 0 7.2 20h9.6a3.2 3.2 0 0 0 3.2-3.2V7.2A3.2 3.2 0 0 0 16.8 4H7.2Zm4.8 2.6A5.4 5.4 0 1 1 6.6 12 5.4 5.4 0 0 1 12 6.6Zm0 2A3.4 3.4 0 1 0 15.4 12 3.4 3.4 0 0 0 12 8.6Zm5.55-3.15a1.25 1.25 0 1 1-1.25 1.25 1.25 1.25 0 0 1 1.25-1.25Z" />
                </svg>
            );
        case 'linkedin':
            return (
                <svg {...props}>
                    <path d="M5.05 3.5A1.55 1.55 0 1 1 3.5 5.05 1.55 1.55 0 0 1 5.05 3.5ZM3.7 8.2h2.7V20H3.7Zm4.38 0h2.58v1.6h.04a2.83 2.83 0 0 1 2.55-1.4c2.72 0 3.22 1.79 3.22 4.12V20h-2.7v-5.94c0-1.41-.03-3.22-1.96-3.22-1.96 0-2.26 1.53-2.26 3.12V20h-2.7Z" />
                </svg>
            );
        case 'telegram':
            return (
                <svg {...props}>
                    <path d="M21.63 4.37a1.55 1.55 0 0 0-1.68-.24L3.11 11.05a1.5 1.5 0 0 0 .11 2.82l4.2 1.45 1.44 4.2a1.5 1.5 0 0 0 2.82.1l6.92-16.84a1.55 1.55 0 0 0-.97-2.01ZM9.36 14.64l-.52 3.08-.95-2.76 8.88-6.48-7.41 6.16Z" />
                </svg>
            );
        case 'signal':
            return (
                <svg {...props}>
                    <path d="M12 2.25c5.39 0 9.75 3.88 9.75 8.66 0 4.79-4.36 8.67-9.75 8.67-.74 0-1.46-.07-2.15-.21l-4.38 2.38 1.3-3.86C4.13 16.38 2.25 13.8 2.25 10.91 2.25 6.13 6.61 2.25 12 2.25Zm0 2c-4.24 0-7.75 2.97-7.75 6.66 0 2.34 1.42 4.46 3.8 5.67l.71.36-.55 1.65 1.97-1.07.54.11c.42.08.85.12 1.28.12 4.24 0 7.75-2.97 7.75-6.67S16.24 4.25 12 4.25Z" />
                </svg>
            );
        case 'whatsapp':
            return (
                <svg {...props}>
                    <path d="M12.04 2C6.57 2 2.12 6.45 2.12 11.92c0 1.75.46 3.46 1.34 4.96L2 22l5.28-1.38a9.86 9.86 0 0 0 4.76 1.22h.01c5.47 0 9.92-4.45 9.92-9.92A9.92 9.92 0 0 0 12.04 2Zm0 18.06h-.01a8.1 8.1 0 0 1-4.12-1.13l-.29-.17-3.13.82.84-3.05-.19-.31a8.08 8.08 0 0 1-1.24-4.3c0-4.46 3.63-8.09 8.1-8.09 4.46 0 8.09 3.63 8.09 8.1a8.1 8.1 0 0 1-8.05 8.13Zm4.44-6.06c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.93-1.18-.71-.63-1.2-1.4-1.34-1.64-.14-.24-.02-.37.1-.49.1-.1.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.41-.54-.42h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.68 2.57 4.08 3.6.57.24 1.02.38 1.37.48.58.18 1.1.16 1.52.1.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28Z" />
                </svg>
            );
        default:
            return null;
    }
}
